"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SensitiveGoodCategory = void 0;
var SensitiveGoodCategory;
(function (SensitiveGoodCategory) {
    SensitiveGoodCategory["AGE_RESTRICTED_PRODUCTS"] = "AGE_RESTRICTED_PRODUCTS";
    SensitiveGoodCategory["LICENSED_WEAPONS"] = "LICENSED_WEAPONS";
    SensitiveGoodCategory["MEMBERSHIPS_SUBSCRIPTIONS_SERVICES"] = "MEMBERSHIPS_SUBSCRIPTIONS_SERVICES";
    SensitiveGoodCategory["NONE"] = "NONE";
    SensitiveGoodCategory["PEER_TO_PEER_MARKETPLACE"] = "PEER_TO_PEER_MARKETPLACE";
    SensitiveGoodCategory["PHARMA_AND_MEDICAL_SERVICES"] = "PHARMA_AND_MEDICAL_SERVICES";
    SensitiveGoodCategory["TRAVEL_TOURS_EVENTS"] = "TRAVEL_TOURS_EVENTS";
})(SensitiveGoodCategory || (exports.SensitiveGoodCategory = SensitiveGoodCategory = {}));
